import {
  useMutation,
  useQuery,
  useQueryClient,
  type UseQueryResult,
} from "@tanstack/react-query";
import { apiFetch } from "@/lib/api";
import { useAuth } from "@/modules/auth/hooks/useAuth";

const key = (userId: string) => ["user-product-access", userId] as const;

export function useProductAccess(userId: string): UseQueryResult<string[]> {
  const { accessToken } = useAuth();
  return useQuery({
    queryKey: [...key(userId), accessToken ? "auth" : "anon"],
    enabled: !!accessToken && !!userId,
    queryFn: async () => {
      const res = await apiFetch<{ productIds: string[] }>(
        `/users/${userId}/product-access`,
        { token: accessToken },
      );
      return res.productIds;
    },
  });
}

export function useSetProductAccess(userId: string) {
  const { accessToken } = useAuth();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (productIds: string[]) =>
      apiFetch<{ productIds: string[] }>(`/users/${userId}/product-access`, {
        method: "PUT",
        body: { productIds },
        token: accessToken,
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["user-product-access", userId] });
    },
  });
}
